
import {
  Component,
  Vue,
} from 'vue-property-decorator';
import { VueDaumPostcode } from 'vue-daum-postcode';

@Component({
  name: 'ReserveManageForm',
  components: {
    VueDaumPostcode,
  },
})
export default class extends Vue {
  private reserveAvailable = false;

  private reserveScope = false;

  // 임시로 추가
  private managePolicyDraw = {
    type: '',
    day: '',
    time: '',
  }

  private limit = [
    {
      typeKey: 'dayCountUse',
      countKey: 'dayCount',
      label: '일',
    },
    {
      typeKey: 'weekCountUse',
      countKey: 'weekCount',
      label: '주',
    },
    {
      typeKey: 'monthCountUse',
      countKey: 'monthCount',
      label: '월',
    },
  ]
}
